// stores/errorStore.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorStore = defineStore('error', () => {
  const messages = ref<string[]>([])

  function setErrors(msgs: string[]) {
    messages.value = msgs
  }

  function clearErrors() {
    messages.value = []
  }

  return { messages, setErrors, clearErrors }
})
